import React from 'react';

/**
 * Watch changes of the URL hash and returns the current hash.
 */
export function useHashChange() {
    return React.useSyncExternalStore(
        (callback) => {
            window.addEventListener('hashchange', callback);
            return () => window.removeEventListener('hashchange', callback);
        },
        // Returns the the current hash
        () => window.location.hash,
        // Fallback
        () => ''
    );
}
